var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpanded(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#3B98D1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.075 8.9998C11.9417 8.9998 11.8127 9.02481 11.688 9.07481C11.5627 9.12481 11.4583 9.19147 11.375 9.27481L6.775 13.8748C6.59167 14.0581 6.5 14.2915 6.5 14.5748C6.5 14.8581 6.59167 15.0915 6.775 15.2748C6.95833 15.4581 7.19167 15.5498 7.475 15.5498C7.75833 15.5498 7.99167 15.4581 8.175 15.2748L12.075 11.3748L15.975 15.2748C16.1583 15.4581 16.3917 15.5498 16.675 15.5498C16.9583 15.5498 17.1917 15.4581 17.375 15.2748C17.5583 15.0915 17.65 14.8581 17.65 14.5748C17.65 14.2915 17.5583 14.0581 17.375 13.8748L12.775 9.27481C12.675 9.17481 12.5667 9.10414 12.45 9.06281C12.3333 9.02081 12.2083 8.9998 12.075 8.9998Z",
    fill: "#F5F5F5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpanded);
export default __webpack_public_path__ + "static/media/expanded.aaf65bc63cbe502080154336f55d8b17.svg";
export { ForwardRef as ReactComponent };